import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import { AssessmentInstanceDto, DeployApplicationType } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AssPlayerImage } from "views/assessment/player/common/AssPlayerImage";
import { AssPlayerTitleHeader } from "views/assessment/player/common/AssPlayerTitleHeader";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    viewData: AssessmentInstanceDto;
    fullScreenMode: boolean;
}

export const AssPlayerSummary: React.FC<IProps> = (props) => {

    const { viewData, fullScreenMode } = props;

    const theme = useTheme();
    const { t } = useTranslation("assessment");
    const [clientHeight, setClientHeight] = useState<number>(0);

    const titleRef = useRef<any>(undefined);

    useEffect(() => {
        setClientHeight(titleRef.current.clientHeight + 8);
    }, [fullScreenMode]);

    const revision = viewData.survRevision!;

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <AssPlayerTitleHeader title={viewData.title} ref={titleRef} />

            <Box sx={{
                height: `calc(${fullScreenMode ? "78vh" : "52vh"} - ${clientHeight}px)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <Grid container spacing={2}>
                    <Grid>
                        <AssPlayerImage viewData={viewData} />
                    </Grid>
                    <Grid size="grow">
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <Stack display="flex" direction="column" spacing={2}>
                                <Typography variant="h2" color={theme.palette.text.primary}>
                                    {t("AssPlayer.Summary.Subtitle")}
                                </Typography>
                                {
                                    revision.startDate && revision.endDate &&
                                    <Typography variant="body1" color={theme.palette.muted.main}>
                                        {t("AssPlayer.Summary.PeriodText")}:
                                        <Typography variant="body1" component="span" color={theme.palette.warning.main}>
                                            {` ${Formaters.performaFullDateRange(revision.startDate, revision.endDate, { replaceClosestDays: false })}`}
                                        </Typography>
                                    </Typography>
                                }
                                <Typography variant="body1" color={theme.palette.muted.main}>
                                    {t("AssPlayer.Summary.TotalQuestionsText")}:
                                    <Typography variant="body1" component="span" color={theme.palette.warning.main}>
                                        {` ${Formaters.number(viewData.totalQuestions, 0)}`}
                                    </Typography>
                                </Typography>
                                {
                                    revision.averagePlayTime &&
                                    <Typography variant="body1" color={theme.palette.muted.main}>
                                        {t("AssPlayer.Summary.AveragePlayTimeText")}:
                                        <Typography variant="body1" component="span" color={theme.palette.warning.main}>
                                            {` ${Formaters.secondsToFullTime(revision.averagePlayTime)}`}
                                        </Typography>
                                    </Typography>
                                }
                                <Typography variant="body1" color={theme.palette.muted.main}>
                                    <strong>{t(viewData.deployApplicationType == DeployApplicationType.LmsManagerEfficacy ? "AssPlayer.Summary.TotalManagerParticipantsText" : "AssPlayer.Summary.TotalParticipantsText")}:</strong>
                                    <Typography variant="body1" component="span" color={theme.palette.warning.main}>
                                        <strong>{` ${Formaters.number(revision.totalParticipants, 0)}`}</strong>
                                    </Typography>
                                </Typography>
                                {
                                    !!revision.averagePoints &&
                                    <Typography variant="body1" color={theme.palette.muted.main}>
                                        <strong>{t("AssPlayer.Summary.AveragePointsText")}:</strong>
                                        <Typography variant="body1" component="span" color={theme.palette.warning.main}>
                                            <strong>{` ${t("AssPlayer.Summary.AverageText", { val: revision.averagePoints, percent: revision.averagePointsPercent })}`}</strong>
                                        </Typography>
                                    </Typography>
                                }
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};
